import React, { useState } from "react";

const MultipleImageInput = ({selectedImages,setSelectedImages}) => {

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to array
    const newImages = files.map((file,index) => ({
      url: URL.createObjectURL(file), // Preview URL
      file: file // Original file object for future processing
    }));
    // newImages=newImages.map((ele,index)=>{
    //     if(!ele.file){

    //     }
    // })
    setSelectedImages( [...newImages]); // Append new images
  };

  const removeImage = (index) => {
    setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index)); // Remove image by index
  };

  return (
    <div>
      <h2>Select Multiple Images</h2>
      <input
        type="file"
        multiple
        accept="image/*"
        onChange={handleImageChange}
      />
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "20px" }}>
        {selectedImages.map((image, index) => (
          <div key={index} style={{ position: "relative" }}>
            <img
              src={image.url}
              alt={`Selected Preview ${index}`}
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
            />
            <button
              onClick={() => removeImage(index)}
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                background: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            >
              X
            </button>
          </div>
        ))}
      </div>
      {/* {selectedImages.length > 0 && (
        <div>
          <h3>Selected Images:</h3>
          <ul>
            {selectedImages.map((image, index) => (
              <li key={index}>{image.file.name}</li>
            ))}
          </ul>
        </div>
      )} */}
    </div>
  );
};

export default MultipleImageInput;
